import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import BuildCompleteViewImage from './EngageCustomersImage'

const copy = {
  heading: `Engage customers on trusted native channels`,
  description: `Deliver unified, personalized experiences on native channels, like email, WhatsApp, and SMS, on a single, consolidated multichannel marketing solution.`,
}

const link = {
  text: `Explore WhatsApp`,
  url: `/product/twilio-engage/whatsapp/`,
}

const features = [
  {
    heading: `Craft data-driven email campaigns that drive results`,
    description: `Engage your customers with precise messaging and targeting with multi-step lifecycle campaigns or one–time email blasts.`,
  },
  {
    heading: `Consolidate your tech stack to drive efficiency at scale`,
    description: `Reduce expenses by centralizing your multichannel marketing while scaling your communications with native email, SMS, and WhatsApp all in one solution.`,
  },
  {
    heading: `Mobile marketing campaigns for each stage of your customer journey`,
    description: `Distribute timely and relevant marketing messages and offers to drive leads, sales, and loyalty across mobile including SMS, MMS and WhatsApp.`,
  },
]
const BuildCompleteView = () => {
  const pageConfig = usePageConfig()

  return (
    <SectionWrapper variant="2Col" reverse={true}>
      <StyledSectionCopy>
        <CopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
        </CopyTextBase>

        <ColumnTrackWrapper>
          <ColumnTrack gap="small">
            {features.map((feature, index) => (
              <FeatureBoxBase key={index} alignment="left">
                <FeatureBox.Body>
                  <FeatureBox.Title>{feature.heading}</FeatureBox.Title>
                  <FeatureBox.Text>{feature.description}</FeatureBox.Text>
                </FeatureBox.Body>
              </FeatureBoxBase>
            ))}
          </ColumnTrack>
        </ColumnTrackWrapper>
        <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
      </StyledSectionCopy>

      <Section.Contents>
        <BuildCompleteViewImage />
      </Section.Contents>
    </SectionWrapper>
  )
}

const SectionWrapper = styled(SectionBase)`
  overflow-x: visible;
`

const StyledSectionCopy = styled(Section.Copy)`
  direction: ltr;
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    justify-self: end;
    max-width: 440px;
  }
`

const ColumnTrackWrapper = styled.div`
  margin-top: 40px;
`

export default BuildCompleteView
